import { render, staticRenderFns } from "./ProjectDefinitionDetail.vue?vue&type=template&id=172b6f81&scoped=true&"
import script from "./ProjectDefinitionDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectDefinitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDefinitionDetail.vue?vue&type=style&index=0&id=172b6f81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b6f81",
  null
  
)

export default component.exports